import React, { Component } from 'react';
import { connect } from 'react-redux';
import persistAbandonedCart from 'state/checkoutPage/abandonedCart/operations/persistAbandonedCart';
// import SaveForLaterModalComponent from './SaveForLaterModalComponent';
import ShareModal from 'components/shareHotels/components/ShareModal';

class SaveForLaterModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isUrlCopied: false,
    };

    this.handleOnClickCopy = this.handleOnClickCopy.bind(this);
    this.handleOnAfterCloseModal = this.handleOnAfterCloseModal.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { modalOpen, persistAbandonedCart } = this.props;
    const { modalOpen: prevModalOpen } = prevProps;

    if (!prevModalOpen && modalOpen) {
      persistAbandonedCart({ saveToBlob: true });
    }
  }

  handleOnClickCopy() {
    const { url } = this.props;
    navigator.clipboard.writeText(url);
    this.setState({ isUrlCopied: true });
  }

  handleOnAfterCloseModal() {
    this.setState({ isUrlCopied: false });
  }

  render() {
    const { modalOpen, onClickClose, url } = this.props;
    const { isUrlCopied } = this.state;

    if (!modalOpen) {
      return null;
    }

    return (
      <ShareModal
        modalOpen={modalOpen}
        shareUrl={url}
        isUrlCopied={isUrlCopied}
        onClickClose={onClickClose}
        onClickCopy={this.handleOnClickCopy}
        onAfterClose={this.handleOnAfterCloseModal}
      />
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    persistAbandonedCart(config) {
      dispatch(persistAbandonedCart(config));
    },
  };
}

export default connect(null, mapDispatchToProps)(SaveForLaterModal);
